import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class TranslationLoader implements TranslateLoader {
    private readonly http = inject(HttpClient);


    getTranslation(lang: string): Observable<Object> {
        return this.getTranslations(lang);
    }

    private getTranslations(langId: string): Observable<Object> {
        return forkJoin([
            this.loadTranslations(`common/${langId}`),
            this.loadTranslations(`app/${langId}`),
            this.loadTranslations(`planner/default/${langId}`)
        ]).pipe(map((translations: any[]) => Object.assign({}, ...translations)));
    }

    private loadTranslations(fileName: string): Observable<Object> {
        return this.http.get(`/assets/lang/${fileName}.json`);
    }
}
